import { Dropdown, Space, message, Modal } from "antd";
import React, { forwardRef, useEffect, useState, useRef } from "react";
import { EditOutlined, MenuOutlined, HomeOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import moment from "moment";
import NewEditModal from "./component/NewEditModal";
import commonFn from "@/utils/commonFn";
import UploadPendingModal from "./component/UploadPendingModal";
import { sortParams } from "./pendingCheckLogic";

import { CustomTable, CustomTableExtend, CustomModal, CustomUpload } from "@/hocComponents";

const MainTable = forwardRef((props, ref) => {
  const [selectedList, setSelectedList] = useState([]);

  const [invoiceModalFlag, setInvoiceModalFlag] = useState(false);
  const [vendorPendingCheckId, setVendorPendingCheckId] = useState([]);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [filePaths, setFilePaths] = useState([]);

  const initTableHead = {
    invoiceDate: null,
    vendid: null,
    tenant: null,
    vendorName: null,
    customerAccount: null,
    invoice: null,
    prop: null,
    unit: null,
    bank: null,
    street: null,
    city: null,
    remark: null,
    amount: null,
    glAcct: null,
    isNeedApproved: null,
    recurring: null,
    isSubmitted: null,
    trust: null,
    groupCode: null,
    udateText: null,
  };
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = "Input") => {
    commonFn.tableFilterFn({
      event,
      key,
      type,
      setTableHead,
      getTableListFn,
      pageSize: 100,
    });
  };

  const initColumns = [
    {
      title: "Action",
      dataIndex: "action",
      titleType: "",
      width: 60,
      render: (text, record) =>
        (commonFn.btnAuthorityFlag("Edit") && (
          <Dropdown
            menu={{
              items: [
                commonFn.btnAuthorityFlag("Edit") && {
                  key: "Edit Pending Check Information",
                  icon: <EditOutlined twoToneColor="#1677FF" />,
                  label: <div>Edit Pending Check Information</div>,
                },
              ],
              onClick: (e) => newEditFn('edit', record),
            }}
            trigger={["click"]}
          >
            <MenuOutlined className="col-blue" />
          </Dropdown>
        )) ||
        null,
    },
    {
      title: "Invoice Date",
      dataIndex: "invoiceDate",
      titleType: "DatePicker",
      isArrayDate: true,
      onChange: (e) => tableFilterFn(e, "invoiceDate", "DatePickerFormat"),
    },
    {
      title: "Vendor Code",
      dataIndex: "vendid",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "vendid"),
    },
    {
      title: "Tnt #",
      dataIndex: "tenant",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "tenant"),
    },
    {
      title: "Vendor Name",
      dataIndex: "vendorName",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "vendorName"),
    },
    {
      title: "Customer #",
      dataIndex: "customerAccount",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "customerAccount"),
    },
    {
      title: "Invoice #",
      dataIndex: "invoice",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "invoice"),
    },
    {
      title: "Prop",
      dataIndex: "prop",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "prop"),
    },
    {
      title: "Unit",
      dataIndex: "unit",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "unit"),
    },
    {
      title: "Bank",
      dataIndex: "bank",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "bank"),
    },
    {
      title: "Street",
      dataIndex: "street",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "street"),
    },
    {
      title: "City",
      dataIndex: "city",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "city"),
    },
    {
      title: "Remark",
      dataIndex: "remark",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "remark"),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      titleType: "Input",
      isSorter: true,
      isAmountFlag: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "amount"),
    },
    {
      title: "Gl Account",
      dataIndex: "glAcct",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "glAcct"),
    },
    {
      title: "Needs Approval",
      dataIndex: "isNeedApproved",
      titleType: 'Select',
      placeholder: "Select Need...",
      isSorter: true,
      sortterMultiple: 3,
      selectOptions: [
        { label: "No", value: '0' },
        { label: "Yes", value: '1' },
      ],
      render: (text) => {
        const tempMatch = {
          0: "No",
          1: "Yes",
        }
        return tempMatch[text] || ""
      },
      onChange: e => tableFilterFn(e, 'isNeedApproved', 'Select'),

    },
    {
      title: "Recurring",
      dataIndex: "recurring",
      titleType: 'Select',
      placeholder: "Select R...",
      isSorter: true,
      sortterMultiple: 3,
      selectOptions: [
        { label: "No", value: 'no' },
        { label: "Yes", value: 'yes' },
      ],
      render: (text) => {
        const tempMatch = {
          'no': "No",
          'yes': "Yes",
        }
        return tempMatch[text] || ""
      },
      onChange: e => tableFilterFn(e, 'recurring', 'Select'),
    },
    {
      title: "Submitted",
      dataIndex: "isSubmitted",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "isSubmitted"),
    },
    {
      title: "Invoice",
      dataIndex: "invoice",
      titleType: "",
      render: (text, record) => {
        if (text == null || text === "") return "";
        return (
          <span
            onClick={() => invoiceFn(record)}
            style={{
              color: "#1890ff",
              cursor: "pointer",
            }}
          >
            View
          </span>
        );
      },
    },
    {
      title: "Trust",
      dataIndex: "trust",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "trust"),
    },
    {
      title: "Group",
      dataIndex: "groupCode",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "groupCode"),
    },
    {
      title: "Updated Date",
      dataIndex: "udate",
      titleType: "Input",
      placeholder: "YYYY-MM-DD",
      isSorter: true,
      onChange: (e) => tableFilterFn(e, "udateText"),
    },
  ];

  const [columns, setColumns] = useState(initColumns);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const sortRef = useRef({});
  const requestRef = useRef(0);
  const actionBusyRef = useRef(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 100,
    total: 0,
  });

  //列表
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead,
    };
    Object.assign(params, sortRef.current);
    const requestId = ++requestRef.current;
    try {
      const response = await http.get(api.pendingCheckShow, { params });
      if (requestId !== requestRef.current) return;
      if (response?.code !== "1") {
        commonFn.modalFailedFn(response || { msg: "Unable to load pending checks." });
        return;
      }
      setTableList((response.data.list || []).map((item, index) => ({
        ...item, "#": (params.page - 1) * params.count + index + 1,
      })));
      setSelectedList([]);
      setPagination({ current: params.page, pageSize: params.count, total: response.data.total || 0 });
    } finally {
      if (requestId === requestRef.current) setTableLoading(false);
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    sortRef.current = sortParams(sorter);
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  const initColunmsFn = () => {
    sortRef.current = {};
    setPagination({
      current: 1,
      pageSize: 100,
      total: 0,
    });
    setTableList([]);
    setSelectedList([]);
    setTableHead(initTableHead);
    setColumns(initColumns);
  };

  useEffect(() => {
    initColunmsFn();
    getTableListFn(1, 100);
  }, [refreshKey]);

  const NewEditModalRef = useRef(null);

  const newEditFn = (type, record = {}) => {
    const modalNameMatch= {
      'add': 'CREATE PENDING CHECK',
      'edit': 'EDIT PENDING CHECK'
    }
    const { vendorPendingCheckId } = record
    NewEditModalRef.current.openModal({
      type,
      modalName: modalNameMatch[type],
      vendorPendingCheckId
    })
  }

  const submitInitFn = () => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  }
  
  const UploadPendingRef = useRef(null);
  
  const uploadPendingFn = () => {
    UploadPendingRef.current.openModal({
      downloadList: [
        {
          iconKey: 'csvIcon',
          text: 'Click Here for File Format Instruction',
          descList: [
            'To Use Upload Pending Check, Please Drag & Drop a CSV File',
            'Upload Pending Check allows users to record add single and multiple pending checks',
            'For the CSV file formatting instructions please click link below',
          ],
        },
      ],
      uploadFileState: {
        url: api.pendingCheckUploadCsv
      }
    })
  }

  const customModalRef = useRef(null);
  const [customModalConfig, setCustomModalConfig] = useState({
    width: 500,
  });

  const runSelectedAction = async (url, successMessage) => {
    if (actionBusyRef.current || !selectedList.length) return;
    actionBusyRef.current = true;
    try {
      const response = await http.post(url, { ids: selectedList.map(item => item.vendorPendingCheckId) });
      if (response?.code === "1") {
        message.success(successMessage);
        await getTableListFn(pagination.current, pagination.pageSize, tableHead);
      } else {
        commonFn.modalFailedFn(response || { msg: "Unable to complete the request." });
      }
    } finally {
      actionBusyRef.current = false;
    }
  };

  const approvalFn = () => runSelectedAction(api.pendingCheckApproval, "Pending checks submitted successfully.");
  const deleteFn = () => runSelectedAction(api.pendingCheckDelete, "Pending checks deleted successfully.");

  const invoiceFn = async(record) => {
    setVendorPendingCheckId(record.vendorPendingCheckId)
    setInvoiceModalFlag(true)
  }

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag("Download") && "download"]}
      >
        <div className="topLeft">
          {(commonFn.btnAuthorityFlag("New") && (
            <Space size="large">
                {commonFn.btnDocFn({ btnFn: () => newEditFn('add') },{
                  imageStyle: { filter: "brightness(0) invert(1)" }
                })}
            </Space>
          )) || null}

          {(commonFn.btnAuthorityFlag("Upload") && (
            <Space size="large">
                {commonFn.btnDocFn({ 
                  name: 'Upload Pending',
                  className: 'btnUpload',
                  btnFn: uploadPendingFn
                },{
                  iconKey: 'upload',
                  imageStyle: { filter: "brightness(0) invert(1)" }
                })}
            </Space>
          )) || null}

          {(commonFn.btnAuthorityFlag("Approval") && (
            <Space size="large">
                {commonFn.btnDocFn({ 
                  name: 'Send to Approval',
                  className: 'btnApproval',
                  btnFn: () => {
                    if (!selectedList.length) {
                      message.warning("Please select at least one item");
                      return;
                    }
                    setCustomModalConfig({
                      width: 'auto',
                      title: 'SUBMIT FOR APPROVAL',
                      content: `Are you sure you want to submit these ${selectedList.length} Pending Check(s) for Approval.`,
                      onOkFn: approvalFn,
                    })
                    customModalRef.current.openModalFn()
                  },
                  extraDoc: (
                    selectedList?.length && <span className="btnCount">
                      {selectedList.length} 
                    </span> || null
                  ),
                },{
                  iconKey: 'approval',
                  imageStyle: { filter: "brightness(0) invert(1)" }
                })}
            </Space>
          )) || null}

          {(commonFn.btnAuthorityFlag("Delete") && (
            <Space size="large">
                {commonFn.btnDocFn({ 
                  name: 'Delete',
                  className: 'btnDel',
                  btnFn: () => {
                    if (!selectedList.length) {
                      message.warning("Please select at least one item");
                      return;
                    }
                    setCustomModalConfig({
                      width: 'auto',
                      title: 'DELETE PENDING CHECK',
                      content: `Are you sure you want to delete ${selectedList.length} Pending Check(s).`,
                      onOkFn: deleteFn,
                    })
                    customModalRef.current.openModalFn()
                  },
                  extraDoc: (
                    selectedList?.length && <span className="btnCount">
                      {selectedList.length} 
                    </span> || null
                  ),
                },{
                  iconKey: 'deleteIcon',
                  imageStyle: { filter: "brightness(0) invert(1)" }
                })}
            </Space>
          )) || null}
        </div>

      </CustomTableExtend>

      <CustomTable
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowSelection={{
          preserveSelectedRowKeys: true,
          type: "checkbox",
          getCheckboxProps: (record) => ({
            disabled: false,
          }),
          selectedRowKeys: selectedList.map(
            (item) => item.vendorPendingCheckId,
          ),
          onChange: (selectedRowKeys, selectedRows) => {
            setSelectedList(selectedRows);
          },
        }}
        rowKey="vendorPendingCheckId"
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
      />

      <NewEditModal
        ref={NewEditModalRef}
        submitInitFn={submitInitFn}
      />

      <CustomModal
        ref={customModalRef}
        customConfig={customModalConfig} 
      />

      <UploadPendingModal
        ref={UploadPendingRef}
        submitInitFn={submitInitFn}
      />

      <Modal
        title="VIEW INVOICE"
        width="50%"
        maskClosable={false}
        open={invoiceModalFlag}
        onCancel={() => (setInvoiceModalFlag(false))}
        footer={false}
      >
        <div
          key={vendorPendingCheckId}
          style={{ height: "100%", display: "flex", flexDirection: "column" }}
        >
          <CustomUpload
            setFilePaths={setFilePaths}
            filePaths={filePaths} 
            setBtnDisabled={setBtnDisabled}
            btnDisabled={btnDisabled}
            isEdit={true}
            foreignId={vendorPendingCheckId || undefined}
            type={'pending_check'}
            customConfig={{
              accept: ".jpg, .jpeg, .png, .pdf",
              noShowUpload: true,
              pageName: 'PendingCheck'
            }}
          />
        </div>
      </Modal>
    </div>
  );
});
export default MainTable;
